// extracted by mini-css-extract-plugin
module.exports = {"checkbox__input":"Checkbox_checkbox__input__1tBwv"};